import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../core/services/session-state.service';
import { GeneralService } from '../services/general.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss']
})
export class CookiesComponent implements OnInit {
  hidden: boolean;
  isMobile: boolean;
  constructor( private sessionStateService: SessionStateService,
              private generalService: GeneralService) { }

  ngOnInit() {
    this.isMobile = this.generalService.isMobile();
  }

  close() {
    this.sessionStateService.setCookiesAcceptance(true);
    this.hidden = true;
  }

  learnMore() {
    if (environment.qa) {
      if (this.sessionStateService.getLang() === 'EN') {
        window.open('https://s3-eu-west-1.amazonaws.com/edpredy-qa-webapp-customer/terms/20100212+-+PCookies+-+Portal+Cloud-eng-GB.pdf');
      } else if (this.sessionStateService.getLang() === 'PT') {
        window.open('https://s3-eu-west-1.amazonaws.com/edpredy-qa-webapp-customer/terms/20100212+-+PPrivacidade+-+Portal+Cloud.pdf');
      } else if (this.sessionStateService.getLang() === 'ES') {
        window.open('https://s3-eu-west-1.amazonaws.com/edpredy-qa-webapp-customer/terms/20100212+-+PCookies+-+Portal+Cloud-spa-ES.pdf');
      } else {
        // Default
        window.open('https://s3-eu-west-1.amazonaws.com/edpredy-qa-webapp-customer/terms/20100212+-+PCookies+-+Portal+Cloud-eng-GB.pdf');
      }
    } else {
      if (this.sessionStateService.getLang() === 'EN') {
        window.open('https://s3-eu-west-1.amazonaws.com/edpredy-portal/terms/20100212+-+PCookies+-+Portal+Cloud-eng-GB.pdf');
      } else if (this.sessionStateService.getLang() === 'PT') {
        window.open('https://s3-eu-west-1.amazonaws.com/edpredy-portal/terms/20100212+-+PCookies+-+Portal+Cloud.pdf');
      } else if (this.sessionStateService.getLang() === 'ES') {
        window.open('https://s3-eu-west-1.amazonaws.com/edpredy-portal/terms/20100212+-+PCookies+-+Portal+Cloud-spa-ES.pdf');
      } else {
        // Default
        window.open('https://s3-eu-west-1.amazonaws.com/edpredy-portal/terms/20100212+-+PCookies+-+Portal+Cloud-eng-GB.pdf');
      }
    }
  }

  cookieAcceptanceStatus() {
    return this.sessionStateService.getCookiesAcceptance();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/cookies/cookies.component.ts